export default "__VITE_ASSET__BVu6E9DB__"